import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";

import { AfterViewInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";

import { merge, Observable, of as observableOf } from "rxjs";
import { catchError, map, startWith, switchMap } from "rxjs/operators";
import { DossierService } from "../core/service/dossier.service";
import { DetailProvisionComponent } from "./detail-provision/detail-provision.component";
import { DossierDTO } from "../core/model/DossierDTO";
@Component({
  selector: "app-provisions",
  templateUrl: "./provisions.component.html",
  styleUrls: ["./provisions.component.scss"],
})
export class ProvisionsComponent implements OnInit, AfterViewInit {
  dossiers: DossierDTO[];

  displayedColumns: string[] = [
    "numDossier",
    "typeDossier",
    "nomClient",
    "montantPret",
    "resteAPayer",
    "dateMiseEnPlace",
    "etatcreance",
    "impayeJour",
    "actions"
  ];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  constructor(
    private modalService: NgbModal,
    private _router: Router,
    private _dossierService: DossierService
  ) {}

  ngOnInit() {}
  ngAfterViewInit() {
    this.getPageDossier("_", 0);
  }

  getPageDossier(filter: String, pageIndex: number): void {
    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(
      () => (this.paginator.pageIndex = pageIndex)
    );

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;

          return this._dossierService.findAllPagingDossierProvision(
            filter,
            this.paginator.pageIndex,
            this.paginator.pageSize,
            this.sort.active,
            this.sort.direction
          );
        }),
        map((data) => {
           // Flip flag to show that loading has finished.
           this.isLoadingResults = false;
           this.isRateLimitReached = false;
           this.resultsLength = data.totalElements;
           return data.content;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      )
      .subscribe((data) => {
        this.dossiers = data;
      });
  }

  addItemModal(numDossier) {
    const modalRef = this.modalService.open(DetailProvisionComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      scrollable: true,
      windowClass: "app-detail-provision",
    });

    modalRef.componentInstance.numDossier = numDossier;
    modalRef.result.then(
      (result) => {
        // on close
        this.getPageDossier("_", 0);
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.getPageDossier(filterValue, 0);
  }

  voirEcheance(numDossier): void {
    this._router.navigate(["/suivi-portefeuille/detail-dossier/" + numDossier]);
  }
}
